<template>
  <div class="common-news-item"><!---->
    <div class="news-title">
      <div class="title-left">
        <a :title="data.title" class="title-text link-href" @click="clickHandle">
          {{data.title}}
        </a>

        <span v-if="sentiment" class="common-positive-negative mr-8" :class="[`is-${data.sensitivity}`]">
          <span>{{sentiment}} {{thePercent}}</span>
        </span>

        <span class="source-text">来源：{{data.site}}</span>
      </div>
      <span class="title-right source-text">{{data.pubdate}}</span>
    </div>
    <div class="expand-text">
      <input type="checkbox" class="exp">
      <div class="text" :class="{'max-height': isOpen}">
        <div class="expand-btn" @click="isOpen=!isOpen">
          {{isOpen?'收起':'展开'}}
          <div class="control fx-none fx-p-center">
            <div :class="['packup',{'is-opened':isOpen}]">
              <slot v-if="$slots.hideBtn" name="hideBtn" />
              <i v-else class="el-select__caret el-input__icon el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <span>{{formatText(data.content)}}</span>
      </div>
    </div>

    <NewsTags :data="data" />

    <DialogNewsDetail v-if="dialogShow !== null" ref="newsDetail" :data="data" :show.sync="dialogShow" />
  </div>
</template>

<script>
import NewsTags from '@/views/industryChainNew/components/newsTags'
import DialogNewsDetail from '@/views/industryChainNew/components/dialogNewsDetail'
export default {
  name: 'newsDocument',
  components: {
    DialogNewsDetail,
    NewsTags
  },
  props: {
    news: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogShow: null,
      isOpen: false
    }
  },
  computed: {
    sentiment() {
      const sensitivity = {
        neutral: '中性',
        positive: '正面',
        negative: '负面',
      }
      return sensitivity[this.data?.sensitivity || 'neutral']
    },
    thePercent() {
      if (this.data?.confidence !== null) {
        return this.data.confidence + '.00%'
      }
      return '--'
    }
  },
  mounted() {
  },
  methods: {
    formatText(text) {
      const div = document.createElement('div')
      div.innerHTML = text
      return div.innerText
    },
    clickHandle() {
      this.dialogShow = true
    }
  },
}
</script>

<style scoped lang="scss">
.common-news-item {
  border-bottom: 1px solid #f6f5f9;
  padding: 24px 0;
  .news-title {
    display: flex;
    align-content: center;
    justify-content: space-between;
    font-size: 1.1428571429rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 5px;
    .title-left {
      display: flex;
      flex: 1;
      align-content: center;
      max-width: calc(100% - 160px);
    }
    .title-text {
      color: inherit;
      max-width: calc(100% - 250px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 14px;
      text-decoration: none;
    }
    .source-text {
      font-size: 0.8571428571rem;
      font-weight: 400;
      color: #86909c;
      line-height: 22px;
      white-space: nowrap;
      padding-left: 10px;
    }
  }
  .expand-text {
    display: flex;
    overflow: hidden;
    .text {
      // color: var(--color);
      line-height: 16px;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: justify;
      position: relative;
      transition: max-height 0.3s;
      max-height: 32px;
      &.max-height {
        max-height: unset;
        .expand-btn {
          margin-left: 0px;
          &::before {
            visibility: hidden;
          }
        }
        &::after {
          visibility: hidden;
        }
      }
      &::before {
        content: "";
        height: calc(100% - 16px);
        float: right;
      }
      &::after {
        content: "";
        width: 999vw;
        height: 999vw;
        position: absolute;
        box-shadow: inset calc(100px - 999vw) calc(30px - 999vw) 0 0 #fff;
        margin-left: -100px;
      }
    }
  }
  .news-tags {
    padding: 8px 0;
    .common-space {
      display: flex;
    }
    .news-tag {
      padding: 2px 4px;
      border-radius: 4px;
      font-size: 0.8571428571rem;
      display: flex;
      align-items: center;
    }
  }
}

.expand-btn {
  // width: 70px;
  height: 16px;
  line-height: 16px;
  font-size: 14px;
  display: flex;
  cursor: pointer;
  margin-left: 24px;
  background: #f7f9fa;
  color: #186bfc;

  position: relative;
  float: right;
  clear: both;

  &::before {
    content: "...";
    position: absolute;
    left: -5px;
    transform: translateX(-100%);
  }
  .el-input__icon {
    height: 100%;
    width: 16px;
    text-align: center;
    transition: all 0.3s;
    font-size: 14px;
    line-height: 16px;
  }
}

.packup {
  user-select: none;
  position: relative;
  cursor: pointer;
  &.is-opened .el-select__caret {
    transform: rotate(180deg);
  }
}
</style>
